import {Fragment} from 'react';
import {Typography} from '@material-tailwind/react';

import ComingSoonSpeaker from '../../assets/svg/homepage/ComingSoonSpeaker.svg';
import ComingSoonMainImg from '../../assets/img/homepage/ComingSoonMainImg.webp';
import ComingSoonMainImgMobile from '../../assets/img/homepage/ComingSoonMainImg.webp';

const ComingSoon = () => {
  return (
    <Fragment>
      <div className="w-full h-[710px] flex justify-center px-4 lg:px-0 lg:h-[550px]">
        <div className="w-full h-full max-w-[1240px] rounded-[30px] bg-[#282B59] gap-4 grid grid-cols-1 overflow-hidden pt-14 lg:grid-cols-2 lg:gap-8 lg:px-[140px] lg:pt-0">
          <div className='w-full h-full flex flex-col items-baseline justify-center gap-4 px-4 lg:py-[60px] lg:px-0 lg:max-h-[600px]'>
            {/*Coming Soon*/}
            <div className='rounded-full w-[213px] gap-[8px] py-[8px] px-[20px] bg-[#59C169] flex items-center justify-center'>
              <Typography
                variant='paragraph'
                className='text-[#282B59] font-nunito font-medium text-[20px] leading-hundred tracking-[0px] text-left'
              >
                Coming Soon
              </Typography>

              <img width={30} height={30} src={ComingSoonSpeaker} alt={ComingSoonSpeaker}/>
            </div>

            <Typography
              variant='h3'
              className='font-nunito max-w-[358px] text-[30px] leading-hundred tracking-[0px] font-black text-white lg:text-[55px]'
            >
              Tap Now & Pay Later
            </Typography>

            <Typography
              variant='h6'
              className='font-nunito font-normal text-[16px] leading-hundred tracking-[0%] text-white max-w-[490px] lg:text-[20px]'
            >
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              No more delays at the terminal. With OrnaMap's new postpaid feature, simply fund your Cowry wallet, tap your card to ride, and settle the fare later. It’s fast, flexible, and built for your daily commute.
            </Typography>
          </div>

          <div className='w-full h-full hidden lg:block lg:mt-20'>
            <img width={470} alt={ComingSoonMainImg} src={ComingSoonMainImg}/>
          </div>

          <div className='w-full h-full px-4 pt-[60px] flex lg:hidden'>
            <img width={470} alt={ComingSoonMainImgMobile} src={ComingSoonMainImgMobile}/>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ComingSoon;